export const UNAUTHORIZED = 400
export const ERROR = 402
export const TOAST_DURATION = 4000
export const TOAST_POSITION = 'bottom-right'
export const API_TIMEOUT = 5000
export const AGE_MIN_LIMIT = 18
export const AGE_MAX_LIMIT = 100

export const VAPID_KEY = 'BPGyvBwZI_Eci5lHA1nZEJ6KVp0NOGX9Fm8l2xZYRF84YACgMIg9h3GO2UgxzOMAKQETMckmyZwYS0isENpH3X8'